var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.11,-2.37891 H -1.10938 V 4252 H 4253.11 V -2.37891",
    style: {
      fill: "#c31830",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 537.531,3289.4 129.035,352.99 h 1.289 V 3289.4 Z m 127.793,-251.72 h 136.621 v 139.16 h 58.243 v 112.56 h -58.243 v 606.08 H 660.219 L 411.027,3265.39 v -88.55 h 254.297 v -139.16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1885.34,1970.86 -763,440.57 V 986.199 l 763,-230.211 V 1970.86",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1969.24,1967.94 V 755.5 l 767.95,230.879 V 2411.38 l -767.95,-443.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3336.15,2447.5 c 0,49.9 -40.43,90.31 -90.21,90.31 -49.93,0 -90.31,-40.41 -90.31,-90.31 v -97.31 h 180.52 v 97.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3178.04,1011.48 h -22.41 l 90.31,-315.511 90.16,315.511 h -22.41 22.41 V 2279.5 h -22.41 -22.42 -23.75 -44.92 -22.15 -22.41 -22.46 V 1011.48 h 22.46",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2901.08,2350.22 -81.79,64.62 V 947.559 l -847.78,-273.95 h -39.24 -7.74 -39.19 L 1041.32,909.398 V 2414.84 l -81.836,-64.62 V 852 L 1881.46,596.781 h 43.07 7.74 43.07 l 850.61,270.071 75.13,22.097 V 2350.22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1329.71,3704.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1544.89,3629.46 v 192.91 c 0,21.72 -9.54,37.09 -31.26,37.09 -21.2,0 -30.75,-15.37 -30.75,-37.09 v -192.91 c 0,-21.72 9.55,-37.09 30.75,-37.09 21.72,0 31.26,15.37 31.26,37.09 z m -122.42,9.55 v 173.81 c 0,56.18 27.56,96.98 91.16,96.98 64.12,0 91.68,-40.8 91.68,-96.98 v -173.81 c 0,-55.65 -27.56,-96.98 -91.68,-96.98 -63.6,0 -91.16,41.33 -91.16,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1637.12,3639.01 v 173.81 c 0,56.18 26.5,96.98 90.09,96.98 66.78,0 85.32,-37.09 85.32,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.43,34.98 -29.14,34.98 -21.73,0 -30.75,-15.37 -30.75,-37.09 v -192.91 c 0,-21.72 9.02,-37.09 30.75,-37.09 21.71,0 29.14,13.78 29.14,34.98 v 66.24 h 55.11 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1961.46,3704.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2184.59,3768.31 -33.91,-222.04 h -56.71 l -48.22,359.29 h 58.29 l 28.08,-227.87 h 0.54 l 30.21,227.87 h 49.28 l 33.38,-227.87 h 0.54 l 27.55,227.87 h 50.88 l -46.64,-359.29 h -57.23 l -35.51,222.04 h -0.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2347.84,3905.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2582.09,3856.28 v -111.82 h 20.14 c 20.66,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.02,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.21,-30.2 83.21,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.23,-69.42 l 57.77,-163.22 h -63.6 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2710.88,3905.56 h 160.58 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2896.91,3905.56 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3080.8,3738.11 h 85.85 v -191.84 h -43.45 v 39.21 c -7.95,-27.02 -24.91,-43.45 -57.77,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.03,96.98 90.63,96.98 66.76,0 86.37,-37.09 86.37,-90.09 v -31.79 h -55.11 v 36.56 c 0,22.26 -8.48,34.98 -30.21,34.98 -21.73,0 -31.26,-15.37 -31.26,-37.09 v -192.91 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.6,0 29.67,11.13 29.67,34.45 v 63.59 h -28.62 v 47.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3198.47,3905.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1271.42,3207.9 v -112.35 h 26.49 c 20.15,0 29.68,10.07 29.68,29.15 v 54.05 c 0,19.08 -9,29.15 -30.2,29.15 z m 0,46.1 h 21.2 c 19.61,0 28.61,10.07 28.61,29.15 v 43.99 c 0,19.6 -9,29.14 -29.14,29.14 h -20.67 z m -60.41,151.56 h 87.44 c 60.41,0 80.55,-28.08 80.55,-78.95 v -36.57 c 0,-30.21 -11.13,-49.29 -36.04,-57.23 30.21,-6.89 45.05,-27.03 45.05,-59.89 v -47.69 c 0,-50.88 -22.79,-78.96 -83.2,-78.96 h -93.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1415.58,3405.56 H 1476 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1508.33,3405.56 h 60.41 v -310.01 h 72.07 v -49.28 h -132.48 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1751.59,3095.55 c 24.9,0 34.44,14.84 34.44,36.57 v 188.13 c 0,21.19 -9.54,36.03 -34.44,36.03 h -25.44 v -260.73 z m 94.85,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.43,-96.45 h -93.27 v 359.29 h 93.27 c 64.65,0 87.43,-40.8 87.43,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2053.68,3405.56 v -271.85 c 0,-55.65 -23.85,-91.68 -85.33,-91.68 -63.59,0 -90.08,36.03 -90.08,91.68 v 271.85 h 60.41 v -277.68 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2136.36,3272.02 v -225.75 h -50.87 v 359.29 h 59.36 l 65.17,-206.14 v 206.14 h 50.35 v -359.29 h -52.99 l -71.02,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2383.34,3238.1 h 85.85 v -191.83 h -43.45 v 39.21 c -7.95,-27.02 -24.92,-43.45 -57.77,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.02,96.98 90.62,96.98 66.77,0 86.38,-37.09 86.38,-90.09 v -31.79 h -55.11 v 36.56 c 0,22.26 -8.48,34.98 -30.21,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.09 v -192.9 c 0,-21.73 9.02,-37.1 29.68,-37.1 19.61,0 29.68,11.13 29.68,34.45 v 63.59 h -28.62 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe04);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-04.7bd0c1425038c4b8580d13479b725515.svg";
export { ForwardRef as ReactComponent };